import {
  BasicButton,
  ButtonGroup,
  LegacyModal,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  PrimaryButton,
} from "@certn/cascadia-react";
import { Trans, useTranslation } from "react-i18next";
import { useOverlayTriggerState } from "react-stately";

export const ConfirmCloseTrustmaticModal = ({
  show,
  onClose,
  onExit,
}: {
  show: boolean;
  onClose: () => void;
  onExit: () => void;
}) => {
  const { t } = useTranslation();
  const modalState = useOverlayTriggerState({});

  if (!show) {
    return null;
  }

  return (
    <ModalOverlay state={modalState}>
      <LegacyModal>
        <ModalHeader
          close={onClose}
          title={t("Incomplete Verification")}
          testID="confirm-close-trustmatic"
        />
        <ModalContent>
          <Trans>
            Are you sure you want to exit the identity verification process?
          </Trans>
        </ModalContent>
        <ModalFooter>
          <ButtonGroup>
            <BasicButton size="medium" onPress={onExit}>
              <Trans>Exit</Trans>
            </BasicButton>
            <PrimaryButton type="submit" size="medium" onPress={onClose}>
              <Trans>Continue Verification</Trans>
            </PrimaryButton>
          </ButtonGroup>
        </ModalFooter>
      </LegacyModal>
    </ModalOverlay>
  );
};
